export enum FileFormat {
  Pdf = 0,
  Word = 1,
  Jpeg = 2,
  Png = 3,
}
